import { css } from '@/styled-system/css';

export const labelStyles = css.raw({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
});
